import { render } from "./BDetail.vue?vue&type=template&id=d4e49bfa&scoped=true"
import script from "./BDetail.vue?vue&type=script&lang=js"
export * from "./BDetail.vue?vue&type=script&lang=js"

import "./BDetail.vue?vue&type=style&index=0&id=d4e49bfa&lang=scss&scoped=true"
import "./BDetail.vue?vue&type=style&index=1&id=d4e49bfa&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4e49bfa"]])

export default __exports__